<div class="field" [formGroup]="control">
  <small class="error" *ngIf="input?.errors?.['required']; else content">
    Seleção obrigatória
  </small>
  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
  <p-dropdown
    [options]="options"
    optionLabel="display"
    optionValue="value"
    [formControlName]="formControlName"
    [disabled]="disabled || !!input?.disabled"
    [inputId]="id"
    [filter]="filter || options.length >= 10"
    [resetFilterOnHide]="true"
    [editable]="editable"
    [placeholder]="placeholder"
    emptyFilterMessage="Nenhum resultado"
    emptyMessage="(Vazio)"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
    (onChange)="outputChange.emit($event)"
  ></p-dropdown>
  <label [for]="id">
    {{ label }}
  </label>
</div>
